import { CustomAxiosHeaders } from '../config/services'
import { getAxiosInterceptor, getHeader } from '../util/axios_helper'

import AdPublishingService from './AdPublishingService'
import AiWrapperService from './AiWrapperService'
import AppEngineService from './AppEngineService'
import AuditService from './AuditService'
import BusinessService from './BusinessService'
import ChatWidgetService from './ChatWidgetService'
import ContactServices from './ContactServices'
import ConversationAiResellingService from './ConversationAIResellingService'
import ConversationsService from './ConversationsService'
import CustomMenuLinkService from './CustomMenuLinkService'
import DocumentService from './DocumentService'
import DocumentsContractsServices from './DocumentContractsService'
import EmailBuilderServices from './EmailBuilderService'
import FunnelsServices from './FunnelServices'
import GlobalSearchServices from './GlobalSearchServices'
import IntegrationOauthService from './IntegrationOauthService'
import IntegrationService from './IntegrationsService'
import LaunchpadService from './LaunchpadService'
import LocationsService from './LocationsService'
import LogsService from './LogsService'
import NotificationService from './NotificationService'
import OauthService from './OauthService'
import OnboardingService from './OnboardingService'
import PaymentServices from './PaymentServices'
import PhoneSystemService from './PhoneSystemService'
import PlatformService from './PlatformService'
import ProductRebillingService from './ProductRebillingService'
import ProductServices from './ProductServices'
import ProspectingCommonService from './ProspectingCommonService'
import ProspectingResellingService from './ProspectingService'
import ScoringService from './ScoringService'
import SeoResellingService from './SeoResellingService'
import SocialMediaService from './SocialMediaService'
import TemplateService from './TemplateService'
import UnauthenticatedService from './UnauthenticatedService'
import UrlService from './UrlService'
import UsersService from './UsersService'
import VideosService from './VideosService'
import VoiceAIService from './VoiceAIService'
import WebshotService from './WebshotService'
import WorkflowsResellingService from './WorkflowsResellingService'
import YextResellingService from './YextResellingService'
import axios from 'axios'
import config from '../config'
import ProspectingOpportunitiesService from './ProspectingOpportunitiesService'

export const requests = (opts: CustomAxiosHeaders) => {
  const { host, headers, useNewToken = false, skipInterceptor = false } = opts
  const baseUrl = host || config.restApiUrl
  const devHeaders = {}
  if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_DEVELOPER_VERSION !== 'default') {
    devHeaders['developer_version'] = process.env.VUE_APP_DEVELOPER_VERSION
  }
  const mergedHeaders = {
    ...getHeader(),
    ...headers,
    ...devHeaders,
  }
  const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: mergedHeaders,
  })

  axiosInstance.interceptors.request.use(getAxiosInterceptor(mergedHeaders, useNewToken, skipInterceptor))

  return axiosInstance
}

export {
  AppEngineService,
  AuditService,
  BusinessService,
  ChatWidgetService,
  ContactServices,
  GlobalSearchServices,
  ConversationAiResellingService,
  ConversationsService,
  DocumentService,
  EmailBuilderServices,
  FunnelsServices,
  IntegrationOauthService,
  IntegrationService,
  LocationsService,
  NotificationService,
  OauthService,
  OnboardingService,
  LaunchpadService,
  LogsService,
  UnauthenticatedService,
  PaymentServices,
  PhoneSystemService,
  PlatformService,
  ProductRebillingService,
  ProductServices,
  ScoringService,
  SocialMediaService,
  TemplateService,
  UrlService,
  UsersService,
  VideosService,
  WebshotService,
  AdPublishingService,
  ProspectingCommonService,
  ProspectingResellingService,
  ProspectingOpportunitiesService,
  YextResellingService,
  VoiceAIService,
  AiWrapperService,
  CustomMenuLinkService,
  WorkflowsResellingService,
  DocumentsContractsServices,
  SeoResellingService,
}
